import React from 'react';

import BaseTypography from 'src/components/Text/BaseTypography';
import Button from 'src/components/Button';
import { InfoOutlined } from '@material-ui/icons';
import history from 'src/history';
import { useAppSelector } from 'src/hooks/useStore';
import {
  Chart,
  type ChartData,
} from 'src/components/HomePage/AnalyticsSection/Chart';

const MAX_CLIENTS = 100;

function getRandomInt(minBoundary: number, maxBoundary: number): number {
  const minInt = Math.ceil(minBoundary);
  const maxInt = Math.floor(maxBoundary);
  return Math.floor(Math.random() * (maxInt - minInt + 1)) + minInt;
}

const today = new Date();
const data: ChartData[] = new Array(30)
  .fill(null)
  .reduce<ChartData[]>((acc, _, i) => {
    const prevTotal = acc[acc.length - 1]?.total ?? 0;
    // Make sure we add some people on day 2, so we're not always multiplying against a 0 total.
    const added =
      i === 1 ? 3 : getRandomInt(2, Math.min(12, MAX_CLIENTS - prevTotal));
    const removed = getRandomInt(0, Math.min(6, prevTotal - 1));
    const date = new Date(today);
    date.setDate(today.getDate() - (30 - i));

    acc.push({
      date: date,
      total: prevTotal + added - removed,
    });

    return acc;
  }, []);

export function EmptyState() {
  const clientUsers = useAppSelector((state) => state.clients.clients);

  return (
    <>
      <header className="pb-6 flex flex-row items-center">
        {/* Unfortunately !important is needed to override MUI styles. */}
        <InfoOutlined className="!w-4 !h-4 pr-1.5" />
        <BaseTypography
          fontType="14Regular"
          className="leading-none flex-1 text-gray-500"
        >
          Metrics will show after you create 10 clients ({clientUsers.length}
          /10 created so far)
        </BaseTypography>
        <Button
          onClick={() => history.push('/clients/users')}
          className="px-2 py-1 text-sm border border-solid border-gray-300 rounded"
          htmlId={'analytics-go-to-crm'}
        >
          Go to CRM
        </Button>
      </header>

      <div className="text-gray-300">
        <Chart data={data} />
      </div>
    </>
  );
}
